
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import Link from "@/components/Link.vue";
import P5 from "p5";
import BookMenu from "@/components/BookMenu.vue";
import ColorScalesHeader from "@/components/ColorScalesHeader.vue";

@Component({
  components: {
    Link,
    BookMenu,
    ColorScalesHeader
  },
})

export default class ArticleColorScalesIntro extends Vue{
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
  }
};
